"use client";
import React from 'react';

interface HeadingSizeProps {
  text: string;
  ClassName?:string;
}

const HeadingSize: React.FC<HeadingSizeProps> = ({ text,ClassName }) => {
  return (
    <h2 className={`text-[28px] sm:text-[32px] md:text-[52px] lg:text-[52px] font-['Ainslie_Sans'] font-[600] text-[#000000] ${ClassName}`}>
      {text}
    </h2>
  );
};

export default HeadingSize;